<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'Create_Account_tr' | translate }}</h1>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      @if (!googleToken) {
        <div class="google-signin">
          <app-google-signin-button />
        </div>
        <h4 style="margin: 0">{{ 'or_use_your_email_pass_tr' | translate }}</h4>
      } @else {
        {{ 'Login_using_google_tr' | translate }}
      }

      <mat-form-field>
        <mat-label>{{ 'Email_tr' | translate }}</mat-label>
        <input formControlName="email" matInput autocomplete="username" />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'Name_tr' | translate }}</mat-label>
        <input formControlName="name" matInput />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'Password_tr' | translate }}</mat-label>
        <input formControlName="password" matInput [type]="showPassword ? 'text' : 'password'" autocomplete="new-password" />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          (click)="showPassword = !showPassword"
        >
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (form.controls.password.hasError('minlength')) {
          <mat-error>{{ 'Password_must_be_at_least_8_characters_tr' | translate }}</mat-error>
        }
        @if (form.controls.password.hasError('required')) {
          <mat-error>{{ 'Password_is_required_tr' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'repeat_Password_tr' | translate }}</mat-label>
        <input
          formControlName="rePassword"
          matInput
          [type]="showRepeatPassword ? 'text' : 'password'"
          autocomplete="new-password"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="showRepeatPassword ? 'Hide password' : 'Show password'"
          (click)="showRepeatPassword = !showRepeatPassword"
        >
          <mat-icon>{{ showRepeatPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error>{{ 'password_does_not_match_tr' | translate }}</mat-error>
      </mat-form-field>

      <form-actions>
        <button type="submit" (click)="register()" [disabled]="form.invalid || !form.dirty" color="primary" mat-raised-button>
          <mat-icon>exit_to_app</mat-icon>
          {{ 'register_tr' | translate }}
        </button>
      </form-actions>

      @if (showV2Fallback) {
        <div [class.recaptcha-attention]="recaptchaNeedsAttention">
          <app-recaptcha-v2-fallback (solved)="onV2Solved($event)" (failed)="onV2Failed()" />
        </div>
      }
    </form>
  </mat-card-content>

  <mat-card-actions>
    <a [routerLink]="['/login']" [queryParams]="backToLoginQueryParams">
      {{ 'back_to_login_page_tr' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
